var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceDocxFileLarge = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 147,
  height: 154,
  viewBox: "0 0 147 154",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#6ws4qwwtna)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 5h96.213L142 41.793V145a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4z",
  fill: "#F0EFEF"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.213 5 142 41.793h-32.787a4 4 0 0 1-4-4V5zM59.337 94.047a37.87 37.87 0 0 1 .279 2.794h.163c.064-.755.19-1.663.375-2.731a43.93 43.93 0 0 1 .54-2.698L68.266 60h9.793l7.835 30.942c.392 1.528.717 3.47.979 5.835h.13c.11-1.632.382-3.514.817-5.65L94.088 60H103l-10.97 45H81.617l-7.474-29.813a65.395 65.395 0 0 1-.735-3.358c-.272-1.379-.441-2.383-.506-3.011h-.13c-.088.732-.255 1.82-.506 3.263a80.107 80.107 0 0 1-.604 3.2L64.643 105H54.066L43 60h9.073l6.825 31.475c.152.647.298 1.506.44 2.572L73 67.94z",
  fill: "#6F95D1"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "6ws4qwwtna",
  x: 3,
  y: 4,
  width: 141,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_388_70"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_388_70",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceDocxFileLarge);
export default ForwardRef;